import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { useState } from "react";
import axios from "axios";
import { Alert } from "@mui/material";

const Login =  () => {
 
  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")
  const[error,setError]=useState(false)

  const handleSubmit = async (event) => {
    event.preventDefault();
    if(error){
      setError(false)
    }
    try {
      const res = await axios({
        method:"POST",
        //url: "https://wolt.dev.softexpres.com/api/login",
        //url:"http://192.168.0.122:6567/api/login",
        url:"https://cloudsoftexpres.com:3001/api/login",
        data:{
          username:username,
          password:password
        }
      })
      if(res){
        localStorage.setItem("token", res.data.token)
        localStorage.setItem("refreshToken", res.data.refreshToken)
        window.location.href = "/home"
      }
    } catch (err) {
      console.log(err)
      setError(true)
    }
  
  };

  return (
    <Container component="main" maxWidth="sm" style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100vh"
    }}>
      <Box
        sx={{
          boxShadow: 3,
          borderRadius: 2,
          px: 4,
          py: 8,
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography component="h1" variant="h5">
          Sign in
        </Typography>
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            fullWidth
            id="username"
            label="Username "
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            name="login-username"
            autoComplete="login-username"
            autoFocus
          />
          <TextField
            margin="normal"
            fullWidth
            name="login-password"
            label="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            type="password"
            id="password"
            autoComplete="login-password"
          />
          {
            error && <Alert severity="error">Username ose password nuk eshte i sakte!</Alert>
          }

          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 4, mb: 4 }}
          >
            Login In
          </Button>
        </Box>
      </Box>
    </Container>
  );
}

export default Login